import {
  MenuItem as MuiMenuItem,
  type MenuItemProps as MuiMenuItemProps,
} from '@mui/material';
import { forwardRef } from 'react';
import type { ElementType } from 'react';

export type MenuItemProps<C extends ElementType = 'li'> = Partial<
  Pick<
    MuiMenuItemProps<C>,
    | 'children'
    | 'sx'
    | 'component'
    | 'selected'
    | 'disabled'
    | 'ref'
    | 'value'
    | 'onClick'
    | 'disableGutters'
    | 'divider'
    | 'dense'
  >
>;

export const MenuItem = forwardRef(
  <C extends ElementType = 'li'>(
    { children, ...props }: MenuItemProps<C>,
    ref: any,
  ) => (
    <MuiMenuItem {...props} ref={ref}>
      {children}
    </MuiMenuItem>
  ),
);
